<template>
  <div :class="$style.container">
    <template v-if="gameState !== null && gameState !== 'null'">
      <div v-if="isConnected && ['PRE_GAME', 'IN_PROGRESS'].includes(gameState)">
        <div v-for="team in teams" :class="$style.team" :key="`team-${team}`" :team="team">
          <div :class="$style.header">
            <img v-if="team === 'radiant'" :class="$style.logo" src="@/assets/imgs/radiant.png" />
            <img v-else :class="$style.logo" src="@/assets/imgs/dire.png" />
            <div :class="[$style.team, $style[team]]">
              <div :class="$style.name">{{ getTeamName(team) }}</div>
              <div :class="$style.faction">{{ team }}</div>
            </div>
          </div>
          <hero-tab v-for="(hero, index) in getHeroes(team)" :hero="hero" :team="team" :key="`${team}-${index}`" />
        </div>
      </div>
    </template>
    <template v-else>
      <div :class="$style.waiting">
        <div :class="$style.loader"></div>
        <div :class="$style.message">Awaiting match data...</div>
      </div>
    </template>
  </div>
</template>

<script>
import HeroTab from './components/tabs.vue'

export default {
  name: 'mobile',
  components: {
    HeroTab
  },
  data: () => {
    return {
      teams: ['radiant', 'dire']
    }
  },
  computed: {
    gameState() {
      return this.$store.getters.gameState
    },
    channelId() {
      return this.$store.getters.channelId
    },
    isConnected() {
      return this.$store.getters.isConnected
    }
  },
  methods: {
    getTeamName(team) {
      return this.$store.getters.teams[team]
    },
    getHeroes(team) {
      if (team === 'radiant') {
        return this.$store.getters.radiantTeam
      }
      return this.$store.getters.direTeam
    },
    recalculateBaseFontSize() {
      const width = document.documentElement.clientWidth || document.body.clientWidth
      const fontSize = width / 22
      document.documentElement.style.fontSize = `${fontSize}px`
    }
  },
  sse: {
    name: 'BaseData',
    endpoint: 'dota2',
    events: ['GameState', 'HeroList', 'Heroes', 'Abilities', 'Inventory', 'Stats', 'Reset']
  },
  mounted() {
    this.recalculateBaseFontSize()
    window.addEventListener('resize', this.recalculateBaseFontSize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.recalculateBaseFontSize)
  }
}
</script>

<style lang="scss" module>
@keyframes loader {
  0% {
    box-shadow: 10vw 0 rgba(white, 0.8), -20vw 0 rgba(white, 0.8);
  }

  50% {
    box-shadow: 10vw 0 rgba(white, 0.8), -10vw 0 rgba(white, 0.8);
  }

  100% {
    box-shadow: 20vw 0 rgba(white, 0.8), -10vw 0 rgba(white, 0.8);
  }
}

.waiting {
  width: 100vw;
  height: 100vh;
  box-shadow: inset 0 2vw 10vw rgba(black, 0.6);
  background-color: #236088;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 4vw;

  .loader {
    width: 8vw;
    aspect-ratio: 1;
    background: rgba(white, 0.8);
    border-radius: 50%;
    animation: loader 0.5s infinite linear alternate;
  }

  .message {
    color: rgba(white, 0.8);
    font-weight: bold;
  }
}

.container {
  width: 100vw;
  height: 100vh;
  background-color: #0e0e0e;
}

.header {
  width: 100%;
  display: flex;
  padding: 2vw;
  gap: 4vw;
  background: #0e0e0e;

  .logo {
    width: 12vw;
    height: 12vw;
    border-radius: 2vw;
    border: 0.5vw solid #236088;
  }

  .team {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: var(--color_white);
    font-weight: bold;

    &.radiant {
      text-shadow: 0.1vw 0.1vw 0.1vw var(--color_dark_green), 0.1vw 0 0.1vw var(--color_dark_green),
        0 0.1vw 0.1vw var(--color_dark_green), 0 0 0.1vw var(--color_dark_green);

      .faction {
        color: var(--color_green);
      }
    }

    &.dire {
      text-shadow: 0.1vw 0.1vw 0.1vw var(--color_dark_red), 0.1vw 0 0.1vw var(--color_dark_red),
        0 0.1vw 0.1vw var(--color_dark_red), 0 0 0.1vw var(--color_dark_red);

      .faction {
        color: var(--color_red);
      }
    }

    .name {
      font-size: 6vw;
      line-height: 6vw;
    }

    .faction {
      font-size: 4vw;
      line-height: 4vw;
      text-transform: capitalize;
    }
  }
}

.title {
  padding: 2vw 0 2vw 0;
  background: black;
  color: var(--color_white);
  text-transform: uppercase;
  text-align: center;
  font-weight: bold;
  font-size: 4vw;
}
</style>
